import AbstractComponent from "components/Abstract";
import ButtonIconSelect from "components/ButtonIconSelect";

import { ReactComponent as BanIcon } from 'icons/pages/app/ban.svg';
import { ReactComponent as DebtIcon } from 'icons/pages/app/debt.svg';
import { ReactComponent as TeethIcon } from 'icons/components/teeth.svg';
import { ReactComponent as FirstVisitIcon } from 'icons/pages/app/firstVisit.svg';
import { ReactComponent as PhoneIcon } from 'icons/pages/app/phone.svg';
import { ReactComponent as SpecialInfoIcon } from 'icons/pages/app/specialInfo.svg';
import { ReactComponent as VipIcon } from 'icons/pages/app/vip.svg';
import { ReactComponent as VisitStatusIcon } from 'icons/pages/app/visitStatus.svg';
import { ReactComponent as VisitStatusInIcon } from 'icons/pages/app/visitStatusIn.svg';
import { ReactComponent as ChildrenIcon } from 'icons/pages/app/children.svg';
import { ReactComponent as BirthdayIcon } from 'icons/pages/app/birthday.svg';

const allMins = Array(37).fill(0).map((it, i) => `mins${i * 5}`);
allMins.shift();

export default class ScheduleViewVisits extends AbstractComponent {

    visResizeStart(flag, visId, e) {
        if (e.button !== 0)
            return;

        const info = this["visitData" + visId];
        const { id, startD, endD, doctorId, cabinetId } = info;

        const nodeOrig = this.visitsNodes[id];
        const node = this._helper.dom.clone(nodeOrig);

        this._helper.dom.display(nodeOrig, 0);
        this._helper.dom.addClass(node, "editing");

        node.vStartD = startD;
        node.vEndD = endD;
        node.vLastDate = startD;
        node.vLastDateEnd = endD;
        node.vLastDoctorId = doctorId;
        node.vLastCabinetId = cabinetId;

        this.clearResize();
        this.resizeCnt = this._helper.on(window, "mousemove", this.visResizeMove.bind(this, flag, info, node));
        this.resizeEndCnt = this._helper.on(window, "mouseup", this.visResizeEnd.bind(this, info, node, nodeOrig));
        this.startY = e.pageY;
    }

    clearResize() {
        this._helper.disconnect(this.resizeCnt);
        this._helper.disconnect(this.resizeEndCnt);
        this.resizeCnt = null;
    }

    visResizeMove(flag, info, node, e) {
        this.setVizResizeStep(flag, info, node, e);
    }

    confirmNo(node, nodeOrig) {
        node.remove();
        this._helper.dom.display(nodeOrig, 1);
    }

    confirmUpdate(info, node, nodeOrig) {
        const { vLastDoctorId, vLastCabinetId, vLastDate, vLastDateEnd } = node;
        const { id, doctorId, cabinetId, beginDate, endDate } = info;

        // Получаем новый родительский элемент из node
        //const newParent = node.parentNode;

        const obj = {
            doctorId: vLastDoctorId,
            cabinetId: vLastCabinetId,
            beginDate: this._helper.date.toStr(vLastDate),
            endDate: this._helper.date.toStr(vLastDateEnd),
        };

        const eaqual = (vLastDoctorId === doctorId && vLastCabinetId === cabinetId && obj.beginDate === beginDate && obj.endDate === endDate);

        if (eaqual || node.vHasIntersect) {
            node.remove();
            this._helper.dom.display(nodeOrig, 1);
            return;
        }

        this._helper.confirm(
            { title: "Подтвердить действие", message: this.tr("Вы изменяете прием - Подтвердить?") },
            this.props.updateVisit.bind(this, id, obj, () => {

                // если будут глюки со скроллами 
                /*// Создаем копию nodeOrig
                const nodeCopy = nodeOrig.cloneNode(true);
                newParent.appendChild(nodeCopy);
                // Скрываем оригинальный элемент
                this._helper.dom.display(nodeOrig, 0);
                delete this.visitsNodes[id];

                let doctorNode = nodeCopy.parentNode;
                let start = this._helper.date.fromStr(doctorNode.dataset.beginDateTime);
                const newFrom = this.getPercentFromTimes(start, vLastDate);
                const newLength = this.getPercentFromTimes(vLastDate, vLastDateEnd);
                this._helper.dom.styleProp(nodeCopy, "start", newFrom);
                this._helper.dom.styleProp(nodeCopy, "length", newLength);

                // Обновляем атрибуты data-begin-date и data-end-date
                nodeCopy.setAttribute('data-begin-date', this._helper.date.toStr(vLastDate));
                nodeCopy.setAttribute('data-end-date', this._helper.date.toStr(vLastDateEnd));

                // Обновляем содержимое элемента timeN
                const timeN = nodeCopy.querySelector('.timeN');
                if (timeN) {
                    const newTimeStr = this._helper.date.toTimeStr(vLastDate) + "-" + this._helper.date.toTimeStr(vLastDateEnd);
                    timeN.textContent = newTimeStr;
                }

                // меняем данные в visits
                this["visitData" + id] = {
                    ...this["visitData" + id],
                    startD: vLastDate,
                    endD: vLastDateEnd,
                    beginDate: obj.beginDate,
                    endDate: obj.endDate,
                    doctorId: vLastDoctorId,
                    cabinetId: vLastCabinetId,
                };*/

                node.remove(node);
            }),
            this.confirmNo.bind(this, node, nodeOrig)
        );
    }

    visResizeEnd(info, node, nodeOrig) {
        this.clearResize();
        this.confirmUpdate(info, node, nodeOrig);
    }

    setVizResizeStep(flag, info, node, e) {
        const { id } = info;
        const { pageY, target } = e;
        const diffY = this.startY - pageY;

        const pxInInt = this.intPx * 5 / this.timeMins;
        const top = this._helper.number.roundByFloor(diffY, pxInInt) / this.intPx;
        let mins = this._helper.number.roundBy(top * this.timeMins, 5);

        let doctorNode = node.parentNode;
        let start = this._helper.date.fromStr(doctorNode.dataset.beginDateTime);
        let end = this._helper.date.fromStr(doctorNode.dataset.endDateTime);

        let startDCopy = new Date(node.vStartD.getTime());
        let endDCopy = new Date(node.vEndD.getTime());
        const diffMins = Math.abs(startDCopy.getTime() - endDCopy.getTime()) / this._helper.date.msInMinute;

        if (flag === -1 || flag === 2) {
            if (flag === -1 && diffMins + mins < 5)
                mins = 5 - diffMins;

            startDCopy.setMinutes(startDCopy.getMinutes() - mins);
        }

        if (flag > 0) {
            if (flag === 1 && mins >= diffMins)
                mins = diffMins - 5;

            endDCopy.setMinutes(endDCopy.getMinutes() - mins);
        }

        let from = this.getPercentFromTimes(start, startDCopy);

        if (flag === 2 && this._helper.dom.hasClass(target, "doctor") && target !== node.parentNode) {
            doctorNode = target;

            target.appendChild(node);

            const startNew = this._helper.date.fromStr(doctorNode.dataset.beginDateTime);
            const endNew = this._helper.date.fromStr(doctorNode.dataset.endDateTime);

            let changedTimes = false;

            if (this._helper.date.diffTime(endDCopy, endNew) > 0) {
                changedTimes = true;
                endDCopy = endNew;
                startDCopy = new Date(endDCopy.getTime());
                startDCopy.setMinutes(startDCopy.getMinutes() - diffMins);
            }
            else if (this._helper.date.diffTime(startNew, startDCopy) > 0) {
                changedTimes = true;
                startDCopy = startNew;
                endDCopy = new Date(startDCopy.getTime());
                endDCopy.setMinutes(endDCopy.getMinutes() + diffMins);
            }
            else if (startNew.getDate() !== startDCopy.getDate()) {
                changedTimes = true;

                const ss = new Date(startNew.getTime());
                ss.setHours(startDCopy.getHours(), startDCopy.getMinutes(), 0, 0);
                startDCopy = ss;

                const ee = new Date(ss.getTime());
                ee.setHours(endDCopy.getHours(), endDCopy.getMinutes(), 0, 0);
                endDCopy = ee;
            }
            from = this.getPercentFromTimes(startNew, startDCopy);

            if (changedTimes) {
                node.vStartD = startDCopy;
                node.vEndD = endDCopy;

                this.startY = pageY;
            }
        }

        if (from < 0 || endDCopy.getTime() > end.getTime())
            return;

        const docVis = this.currentDoctorVisits[doctorNode.dataset.idDate] || [];
        const startDTime = startDCopy.getTime();
        const endDTime = endDCopy.getTime();
        let hasIntersect = false;
        for (let i in docVis) {
            const { visId, beginTime, endTime } = docVis[i];
            if (visId === id)
                continue;

            hasIntersect = (startDTime < endTime && endDTime > beginTime);
            if (hasIntersect)
                break;
        }

        if (hasIntersect && flag < 2)
            return;

        const length = this.getPercentFromTimes(startDCopy, endDCopy);

        const doctorId = parseInt(doctorNode.dataset.id, 10);
        const cabinetId = parseInt(doctorNode.dataset.cabinetId, 10);

        if (node.vLastDate.getTime() === startDCopy.getTime() && node.vLastDateEnd.getTime() === endDCopy.getTime() && node.vLastDoctorId === doctorId && node.vLastCabinetId === cabinetId)
            return;

        this.setVizResizeStyle(node, from, length, startDCopy, endDCopy, hasIntersect);

        node.vHasIntersect = hasIntersect;
        node.vLastDate = startDCopy;
        node.vLastDateEnd = endDCopy;
        node.vLastDoctorId = doctorId;
        node.vLastCabinetId = cabinetId;
    }

    setVizResizeStyle(node, from, length, startDCopy, endDCopy, hasIntersect) {
        const diff = this.getShDiff(startDCopy, endDCopy);

        this._helper.dom.removeClass(node, allMins);
        this._helper.dom.addClass(node, "mins" + diff);
        this._helper.dom.addRemoveClass(node, "intersect", hasIntersect);

        this._helper.dom.styleProp(node, "start", from);
        this._helper.dom.styleProp(node, "length", length);

        const timeNode = node.querySelector(".timeN");
        const durNode = node.querySelector(".durN");

        const timeStr = this._helper.date.toTimeStr(startDCopy) + "-" + this._helper.date.toTimeStr(endDCopy);
        const timeStrVal = this._helper.date.formatTimeDuration(endDCopy, startDCopy);

        timeNode.innerText = timeStr;
        durNode.innerText = "(" + timeStrVal + ")";
    }

    editVisit(info, client) {
        this.props.openAddVisit(info, client, this.props.refreshVisits);
    }

    cancelVisitDialog(id, hasClient, doctorIdDate) {
        if (hasClient)
            return this._helper.openDialog("cancelApp", this.cancelVisit.bind(this, id, doctorIdDate));

        this._helper.confirm(
            { title: "app.cancelApp", message: this.tr("app.cancelAppConfirm") },
            this.cancelVisit.bind(this, id, doctorIdDate, { replaceReasonId: null, replaceReasonComment: "" })
        );
    }

    onSetOrthopedicWork(id, { value }) {
        this.props.updateVisit(id, {
            isOrthopedicWork: value
        });
    }

    confirmOrthopedicWork(id) {
        return this._helper.openDialog("orthopedic", this.onSetOrthopedicWork.bind(this, id));
    }

    async cancelVisit(id, doctorIdDate, { replaceReasonId, replaceReasonComment }) {
        const resp = await this._request.invoices.getInvoiceByVisitId(id);
        if (resp?.data?.length > 0) {
            this._helper.showNotifyPopup({
                type: "error",
                label: this.tr("Ошибка отмены визита"),
                text: this.tr(`По данному визиту сформирован счет от ${this._helper.date.toDateStr(resp?.data[0].createdTime)}, для отмены визита нужно отменить счет`),
            });
        } else {
            this.props.updateVisit(id, {
                status: "WI_CANCELED",
                replaceReasonId,
                replaceReasonComment
            }, () => {
                /*const nodeOrig = this.visitsNodes[id];
                if (nodeOrig) {
                    this._helper.dom.display(nodeOrig, 0);
                    delete this.visitsNodes[id]; // Удаляем ссылку на узел из объекта visitsNodes
                }

                const index = this.currentDoctorVisits[doctorIdDate].findIndex(it => it.visId === id);
                if (index !== -1)
                    this.currentDoctorVisits[doctorIdDate].splice(index, 1);*/
            });
        }
    }

    moveVisitToBuffer(id, client) {
        const addedToBuffer = this._helper.date.toStr();
        const fio = this._helper.string.formatFullName(client);
        const text = `^${this.tr("appointment.clientMoved").replace("$1", fio)}`;

        this.props.updateVisit(id, {
            status: "WI_BUFFER",
            addedToBuffer,
        }, this._helper.showNotify.bind(this._helper, "app.moveApp", text));
    }

    openClient(id, props) {
        this._helper.openClient(id, props);
    }

    checkShowTooltip(e) {
        const node = this._helper.dom.getParentByClass(e.target, "visit");
        const nodes = node ? Array.from(node.querySelectorAll(".checkT")) : [];

        const hasHidden = nodes.find(n => {
            if (this._helper.dom.hasClass(n, "comment") && n.scrollWidth > n.clientWidth)
                return true;

            return this._helper.dom.style(n, "display") === 'none';
        });

        if (!hasHidden)
            return;

        node.vTooltipText = "";
        node.dataset.tooltipMaxWidth = 300;
        nodes.forEach(n => {
            if (this._helper.dom.hasClass(n, "mainInfo"))
                return;

            node.vTooltipText += n.outerHTML;
        });

        this._helper.showTooltip(node);
    }

    async sendVisitSms(client, { beginDate, doctorId }) {
        const { id, fname, sname } = client;
        const date = this._helper.date.toTimeDateStr(beginDate);
        const docName = this._helper.getDoctorNameById(doctorId);
        const fio = this._helper.string.formatFullName(client, "short");

        const smsTemplate = this._helper.getCurrClinic()?.smsTemplateList?.find(it => it.name === "sms") || {};
        const templ = smsTemplate?.template || smsTemplate?.defaultTemplate || "";

        const text = templ.replace("ИмяОтчествоПациента", `${fname} ${sname}`.trim())
            .replace("ВремяИДатаВизита", `${date}`)
            .replace("ФИОДоктора", `${docName}`);

        this._helper.showLoading();
        const resp = await this._request.messages.sendClientSms(id, text);
        this._helper.hideLoading();

        const textNf = "^" + this.tr("notifications.visitSmsMessage").replace("$1", date).replace("$2", fio);
        this._helper.showRequestSuccess(resp, "notifications.visitSmsTitle", textNf);
    }

    async confirmAcceptance({ comment1, id }) {
        this.props.updateVisit(id, {
            callConfirmed: true,
            comment1
        });
    }

    getVisitInIcon(id, arrivalTime, leavingTime, clientInfo, isTop) {
        const cb = leavingTime ? null : () => {
            const time = this._helper.date.toStr();
            const key = !arrivalTime ? "arrivalTime" : "leavingTime";
            const info = { [key]: time };

            /*if (arrivalTime && !leavingTime && clientInfo.status === "NOVICE")
                info.clientStatus = "PERMANENT";*/

            this.props.updateVisit(id, info);

        };

        const clMain = isTop ? " visitStatusTop" : "";

        if (arrivalTime && !leavingTime)
            return <VisitStatusInIcon className={"hand" + clMain} data-tooltip="app.inClinicStatus" onClick={cb} width={16} height={16} />;

        const cl = leavingTime ? " leaved" : " hand";
        const tt = leavingTime ? "app.outClinicStatus" : "app.noneClinicStatus";

        return <VisitStatusIcon className={"inState" + cl + clMain} data-tooltip={tt} onClick={cb} width={16} height={16} />;
    }

    stopDownEvFn() {
        return this._helper.stopEvent.bind(null);
    }

    getShDiff(startD, endD) {
        const diffMins = Math.abs(endD.getTime() - startD.getTime()) / this._helper.date.msInMinute;
        return this._helper.number.roundByFloor(diffMins, 5) || 5;
    }

    insertVisitTopActions(info, client, isCreated, VisitTopIcon, doctorIdDate) {
        const { callConfirmed } = info;
        const { id, phoneNumber } = client;

        const confText = this.tr("appointment", callConfirmed ? "appConfirmed" : "confirmApp");
        const confCl = callConfirmed ? "confirmed" : "hand";
        const confCb = callConfirmed ? null : this._helper.confirm.bind(null, { title: confText, message: this.tr("appointment.confirmAppText") }, this.confirmAcceptance.bind(this, info));

        const dotsItems = [
            { name: this.tr("app.changeApp"), onClick: this.editVisit.bind(this, { ...info, mode: "edit" }, client) },
            { name: this.tr("app.moveApp"), onClick: this.moveVisitToBuffer.bind(this, info.id, client) },
            { name: this.tr("app.cancelApp"), onClick: this.cancelVisitDialog.bind(this, info.id, !!id, doctorIdDate) },
            { name: this.tr("app.showAllApps"), onClick: this.openClient.bind(this, client.id, { tab: "visits" }) },
            { line: true },
            { name: this.tr("Ортопедическая работа"), onClick: this.confirmOrthopedicWork.bind(this, info.id) },
            { name: this.tr("app.formClientDoc"), onClick: null },
            { name: this.tr("app.bill"), onClick: this.openClient.bind(this, id, { tab: "invoices", subTab: "forPayment" }) },
            { name: this.tr("app.sendVisitSms"), onClick: this.sendVisitSms.bind(this, client, info) },
            { name: this.tr("app.diaryFill"), onClick: this.openClient.bind(this, id, { tab: "treatment" }) },
            { name: this.tr("app.inspectionFill"), onClick: this.openClient.bind(this, id, { tab: "treatment" }) },
            { name: this.tr("app.treatmentPlan"), onClick: this.openClient.bind(this, id, { tab: "treatmentPlan" }) },
        ];

        const showVisit = { name: this.tr("main.showVisit"), onClick: this.editVisit.bind(this, { ...info, mode: "show" }, client) };

        return (
            <div className="actionsTop flex centerV gap8" onMouseDown={this.stopDownEvFn()}>
                {VisitTopIcon}
                {!!phoneNumber && (
                    <PhoneIcon
                        className={"phoneIcon " + confCl}
                        data-tooltip={confText}
                        onClick={confCb}
                        width={16}
                        height={16}
                    />
                )}
                <ButtonIconSelect
                    name={"dots"}
                    type={"icon"}
                    items={!isCreated ? [showVisit, dotsItems[2]] : id ? dotsItems : [dotsItems[0], dotsItems[1], dotsItems[2]]}
                    onClick={this._helper.hideTooltip.bind(this._helper)}
                />
            </div>
        );
    }

    insertVisitBottomActions(client, visitIsFirstStatus, comment1, isOrthopedicWork) {
        const { hasDuty, vipStatus, /*specNotes,*/ status, personalData } = client;
        const { SPEC_NOTES } = personalData || {};

        const isbaned = status === "BLACK_LIST";
        //const isNovice = status === "NOVICE";
        const isNovice = visitIsFirstStatus;

        return (
            <div className="flex1 flex gap8">
                {!!hasDuty && <DebtIcon width={16} height={16} />}
                {!!vipStatus && <VipIcon width={16} height={16} />}
                {isbaned && <BanIcon width={16} height={16} />}
                {isNovice && <FirstVisitIcon width={16} height={16} />}
                {!!SPEC_NOTES && <SpecialInfoIcon width={16} height={16} data-tooltip={SPEC_NOTES} data-tooltip-max-width={400} />}
                {!!comment1 && <div className="wrapRetVis">
                    <SpecialInfoIcon width={16} height={16} data-tooltip={comment1} data-tooltip-max-width={400} />
                </div>}
                {isOrthopedicWork && <TeethIcon width={16} height={16} />}
            </div>
        );
    }

    insertVisit(key, doctorId, data, { originalBeginTime, originalEndTime, eaqualVisits, currentTime, canceledMode, time }) {
        const start = this._helper.date.fromStr(originalBeginTime);
        const end = this._helper.date.fromStr(originalEndTime);

        const visId = data.id;
        const {
            beginDate, endDate,
            cabinetId, status, client, comment,
            preparationTimeBegin, preparationTimeEnd,
            arrivalTime, leavingTime, comment1,
            changedBy, changedTime, reasonId, replaceReasonId, replaceReasonComment,
            createdBy, createdTime, visitIsFirstStatus, futureVisitExist, isOrthopedicWork
        } = data;

        const info = client || {};
        const { id, birthday } = info;

        const eqKey = `${beginDate + endDate}`;
        if (!eaqualVisits[eqKey]?.toFixed)
            eaqualVisits[eqKey] = 0;
        else
            eaqualVisits[eqKey]++;

        const left = eaqualVisits[eqKey];

        const startD = this._helper.date.fromStr(beginDate);
        const endD = this._helper.date.fromStr(endDate);

        const from = this.getPercentFromTimes(start, startD);
        const length = this.getPercentFromTimes(startD, endD);
        const diff = this.getShDiff(startD, endD);

        const isCreated = status === "WI_CREATED";
        const isCanceled = status === "WI_CANCELED";
        const name = this._helper.string.formatFullName(info);
        const timeStrVal = !isCreated ? this.tr("appStatuses." + status) : this._helper.date.formatTimeDuration(endD, startD);
        const timeStrStart = "(" + timeStrVal + ")";
        const timeStr = this._helper.date.toTimeStr(startD) + "-" + this._helper.date.toTimeStr(endD);

        const bday = birthday ? this._helper.date.toDateStr(birthday) : "";
        const bdayDate = birthday ? this._helper.date.fromStr(birthday) : "";
        const isTodayBday = birthday ? (bdayDate.getMonth() === startD.getMonth() && bdayDate.getDate() === startD.getDate()) : false;
        const age = birthday ? this._helper.date.getAge(birthday) : 100;
        const isChild = age < this._config.childAge;

        const resTopCl = preparationTimeBegin ? " active" : "";
        const resBottomCl = preparationTimeEnd ? " active" : "";

        const cl = ["visit", "flex", "pos", "abs", "rad8", "mins" + diff];

        if (!client)
            cl.push("visless");
        if (isCreated)
            cl.push("created");
        if (isCanceled)
            cl.push("canceled");
        if (visitIsFirstStatus)
            cl.push("firstvisit");
        else if (!futureVisitExist && client && !isCanceled)
            cl.push("futureVisitExist");
        else if (reasonId === 22)
            cl.push("profosmotr");

        const beginTime = startD.getTime();
        const endTime = endD.getTime();

        const doctorIdDate = `${doctorId}_${cabinetId}_${time}`;
        this.currentDoctorVisits[doctorIdDate] && this.currentDoctorVisits[doctorIdDate].push({ beginTime, endTime, visId });

        const editProps = { startD, endD, start, end, currentTime, beginDate, endDate, doctorId, cabinetId, id: visId };
        this["visitData" + visId] = editProps;

        const changedInfo = (canceledMode && changedBy) ? this.props.getDoctorById(changedBy) : {};
        const createdInfo = (canceledMode && createdBy) ? this.props.getDoctorById(createdBy) : {};
        const changedTs = (canceledMode && changedTime) ? ` (${this._helper.date.toDateTimeStr(changedTime)})` : "";
        const createdTs = (canceledMode && createdTime) ? ` (${this._helper.date.toDateTimeStr(createdTime)})` : "";
        const replaceText = replaceReasonComment || this._helper.getReplaceReason(replaceReasonId);
        const reasonName = this._helper.getReason(reasonId);

        const VisitTopIcon = (isCreated && !!id) ? this.getVisitInIcon(visId, arrivalTime, leavingTime, info, 1) : <></>;

        return (
            <div
                key={key}
                ref={el => this.visitsNodes[visId] = el}
                data-begin-date={beginDate}
                data-end-date={endDate}
                className={cl.join(" ")}
                style={{
                    "--start": from,
                    "--length": length,
                    "--left": left,
                }}
                onMouseDown={this._helper.stopEvent.bind(this._helper)}
                onMouseEnter={this.checkShowTooltip.bind(this)}
                onMouseLeave={this._helper.hideTooltip.bind(this._helper)}
            >
                {isCreated && (
                    <div
                        className={"resizer top pos abs" + resTopCl}
                        onMouseDown={!isCreated ? null : this.visResizeStart.bind(this, -1, visId)}
                    ></div>
                )}
                <div
                    className="flex1 flex col gap8 hidden"
                    onMouseDown={!isCreated ? null : this.visResizeStart.bind(this, 2, visId)}
                >
                    <div className="checkT mainInfo flex1 flex col hidden">
                        <div className="flex centerV gap8">
                            <div className="checkT timeLabel flex1 flex gap8 text p1 lineHidden">
                                <div className="timeN">{timeStr}</div>
                                <div className="durN">{timeStrStart}</div>
                            </div>
                            {this.insertVisitTopActions(data, info, isCreated, VisitTopIcon, doctorIdDate)}
                        </div>
                        <div className="checkT name text p1 hand lineHidden"
                            onMouseDown={this._helper.stopEvent.bind(this._helper)}
                            onClick={this.openClient.bind(this, id, {})}>
                            {name}
                        </div>
                        {!canceledMode && (
                            <div className="checkT bday flex centerV gap4 info text p1 lineHidden">
                                {bday}
                                {isChild && <ChildrenIcon />}
                                {isTodayBday && <BirthdayIcon />}
                            </div>
                        )}
                        {!!reasonName && (<div className={`checkT reason info text p1 lineHidden ${!client ? "vl" : ""}`}>{reasonName}</div>)}
                        {!!comment && (<div className={`checkT comment hidden text p2 ${!client ? "vl" : ""}`}>{comment}</div>)}
                        {canceledMode && !!changedInfo?.lname && (<>
                            <div className="checkT replace byName text p2">{this.tr("main.createBy") + ": " + this._helper.string.formatFullName(createdInfo, "short") + createdTs}</div>
                            <div className="checkT replace byName text p2">{this.tr("app.changedBy") + ": " + this._helper.string.formatFullName(changedInfo, "short") + changedTs}</div>
                        </>
                        )}
                        {canceledMode && (
                            <div className="checkT replace text p2">{this.tr("app.cancelReason") + ": " + replaceText}</div>
                        )}
                    </div>
                    {!isCanceled && (
                        <div className="checkT bottomActions flex centerV gap8">
                            {this.insertVisitBottomActions(info, visitIsFirstStatus, comment1, isOrthopedicWork)}
                            {isCreated && !!id && (
                                <div onMouseDown={this.stopDownEvFn()}>
                                    {this.getVisitInIcon(visId, arrivalTime, leavingTime, info, 0)}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {isCreated && (
                    <div
                        className={"resizer bottom pos abs" + resBottomCl}
                        onMouseDown={!isCreated ? null : this.visResizeStart.bind(this, 1, visId)}
                    ></div>
                )}
            </div>
        );
    }

}
